import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "curiculum-vitae-div" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left middle-left clickable" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  id: "first-step-cv",
  class: "display-column"
}
const _hoisted_5 = {
  id: "first-div-id",
  class: "first-div fade-in-top"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "first-span"
}, " Bacccalauréat scientifique - Lycée Européen Villers-Cotterets ", -1)
const _hoisted_7 = {
  class: "span-content",
  id: "first-span-content-id"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left clickable caret-cursus" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "second-div-id",
  class: "one-line-fade-from-right hide"
}, null, -1)
const _hoisted_11 = {
  id: "third-div-id",
  class: "second-div hide"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-right clickable caret-cursus" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "span-content",
  id: "second-span-content-id"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "second-span"
}, " Diplôme universitaire et technologique de génie mécanique et productique - IUT Reims Champagne Ardennes ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  id: "line-two-div-id",
  class: "one-line-fade-from-left hide"
}, null, -1)
const _hoisted_17 = {
  id: "fifth-div-id",
  class: "third-div hide"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "third-span"
}, " Ingénieur spécialité mécanique - Ecole Centrale de Nantes ", -1)
const _hoisted_19 = {
  class: "span-content",
  id: "third-span-content-id"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left clickable caret-cursus" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  id: "second-step-cv",
  class: "display-column hide"
}
const _hoisted_23 = {
  id: "sixth-div-id",
  class: "first-div fade-in-top"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "fourth-span"
}, " Contrat professionnalisant, reconversion au métier de développeur full stack (test de perf et dev) ", -1)
const _hoisted_25 = {
  class: "span-content",
  id: "fourth-span-content-id"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left clickable caret-cursus" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  id: "seventh-div-id",
  class: "one-line-fade-from-right hide"
}, null, -1)
const _hoisted_29 = {
  id: "eighth-div-id",
  class: "second-div hide"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-right clickable caret-cursus" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  class: "span-content",
  id: "fifth-span-content-id"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "fifth-span"
}, " Développeur full stack en régie sur des applications orientées clients légers à destination de grands distributeurs internationaux ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  id: "ninth-div-id",
  class: "one-line-fade-from-left hide"
}, null, -1)
const _hoisted_35 = {
  id: "tenth-div-id",
  class: "third-div hide"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "hide",
  id: "sixth-span"
}, " Responsable du développement et de la livraison d’applications orientées webs, mobiles et cloud (back et front) ", -1)
const _hoisted_37 = {
  class: "span-content",
  id: "sixth-span-content-id"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left clickable caret-cursus" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right middle-right clickable" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  id: "caret-down-cv",
  class: "fas fa-angle-down middle-bottom pulse hide clickable"
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPresentationPage()))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("h3", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reveal('first-span')))
          }, "2009 Bac S"),
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reveal('first-span'))),
            class: "caret-left"
          }, _hoisted_9)
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reveal('second-span'))),
          class: "caret-right"
        }, _hoisted_13),
        _createElementVNode("span", _hoisted_14, [
          _createElementVNode("h3", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reveal('second-span')))
          }, "2012 DUT GMP"),
          _hoisted_15
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, [
          _createElementVNode("h3", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reveal('third-span')))
          }, "2016 Diplôme d'ingénieur MECA"),
          _createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reveal('third-span'))),
            class: "caret-left"
          }, _hoisted_21)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("span", _hoisted_25, [
          _createElementVNode("h3", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reveal('fourth-span')))
          }, " 2017 Sopra Steria - Ingénieur études et développement "),
          _createElementVNode("span", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.reveal('fourth-span'))),
            class: "caret-left"
          }, _hoisted_27)
        ])
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("span", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.reveal('fifth-span'))),
          class: "caret-right"
        }, _hoisted_31),
        _createElementVNode("span", _hoisted_32, [
          _createElementVNode("h3", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reveal('fifth-span')))
          }, " 2018 Neo Soft - Consultant développeur "),
          _hoisted_33
        ])
      ]),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("span", _hoisted_37, [
          _createElementVNode("h3", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.reveal('sixth-span')))
          }, " 2020 SYD - Développeur Full Stack "),
          _createElementVNode("span", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reveal('sixth-span'))),
            class: "caret-left"
          }, _hoisted_39)
        ])
      ])
    ]),
    _createElementVNode("span", {
      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToCompentencesPage()))
    }, _hoisted_41),
    _createElementVNode("span", {
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.switchOnNextStep()))
    }, _hoisted_43)
  ]))
}